/** Safe URL hand-off from the Bartly landing page to the existing iframe. */
(function () {
  'use strict';
  var frame = document.querySelector('[data-pg-bartly-frame]');
  var appOrigin = 'https://noesis.pixelgipfel.ch';
  function syncTheme() {
    if (!frame || !frame.contentWindow || new URL(frame.src).origin !== appOrigin) return;
    var theme = document.documentElement.getAttribute('data-theme');
    if (theme === 'light' || theme === 'dark') {
      frame.contentWindow.postMessage({ type: 'pg:theme', version: 1, theme: theme }, appOrigin);
    }
  }
  if (frame) {
    frame.addEventListener('load', syncTheme);
    document.addEventListener('pg:theme-change', syncTheme);
    window.addEventListener('message', function (event) {
      if (event.origin === appOrigin && event.source === frame.contentWindow &&
          event.data && event.data.type === 'pg:theme-ready' && event.data.version === 1) syncTheme();
    });
    syncTheme();
  }
  var params = new URLSearchParams(window.location.search);
  var preset = params.get('preset') || '';
  if (frame && /^[a-z0-9][a-z0-9-]{0,254}$/.test(preset)) {
    var frameUrl = new URL(frame.getAttribute('src'));
    if (frameUrl.origin === 'https://noesis.pixelgipfel.ch') {
      frameUrl.searchParams.set('preset', preset);
      frame.src = frameUrl.toString();
      // The "new tab" link opens the same build as the embedded window.
      var newTab = document.querySelector('[data-pg-bartly-newtab]');
      if (newTab) newTab.href = frameUrl.toString();
    }
  }

  var login = document.querySelector('[data-pg-bartly-login]');
  if (login) {
    var loginUrl = new URL(login.getAttribute('href'), window.location.origin);
    if (loginUrl.origin === window.location.origin) {
      loginUrl.searchParams.set('return_to', window.location.pathname + window.location.search);
      login.href = loginUrl.pathname + loginUrl.search + loginUrl.hash;
    }
  }
})();
